import { authSlice } from '@store';
import { Button, Flex, theme, Typography } from '@styles';
import { oneOf } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { capitalizeFirstLetter } from '../../helpers';

const LanguageSwitcher = ({ variant }) => {
  const { language } = useSelector((state) => state.authSlice);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const isSelected = (lang) => lang === language;

  const handleLanguageChange = (lang) => {
    dispatch(authSlice.actions.setLanguage(lang));
    i18n.changeLanguage(lang);
  };

  const getButtonLayoutProps = (lang) => {
    const layoutProps = {
      contained: {
        color: isSelected(lang)
          ? theme.colors.black[100]
          : theme.colors.white[100],
        text: capitalizeFirstLetter(lang),
        variant: isSelected(lang) ? 'primary' : 'textButton',
      },
      text: {
        color: isSelected(lang)
          ? theme.colors.schoolBusYellow
          : theme.colors.white[100],
        text: lang === 'en' ? 'ENG' : 'УКР',
        variant: 'textButton',
      },
    };

    return layoutProps[variant];
  };

  return (
    <Flex alignItems="center" gap={10}>
      <Button
        as={Typography}
        cursor="pointer"
        fontWeight={600}
        height={38}
        onClick={() => handleLanguageChange('en')}
        width={38}
        {...getButtonLayoutProps('en')}
      >
        {getButtonLayoutProps('en').text}
      </Button>
      {variant === 'text' && (
        <Typography color={theme.colors.white[100]}>|</Typography>
      )}
      <Button
        as={Typography}
        cursor="pointer"
        fontWeight={600}
        height={38}
        onClick={() => handleLanguageChange('ua')}
        width={38}
        {...getButtonLayoutProps('ua')}
      >
        {getButtonLayoutProps('ua').text}
      </Button>
    </Flex>
  );
};

LanguageSwitcher.defaultProps = {
  variant: 'text',
};

LanguageSwitcher.propTypes = {
  variant: oneOf(['text', 'contained']),
};

export default LanguageSwitcher;
